import { ChatAiWidget } from "@sendbird/chat-ai-widget";
import { OnWidgetOpenStateChangeParams } from "@sendbird/chat-ai-widget/dist/src/const";
import config from 'api/config';
import { useEffect, useState } from "react";
const appId = config.sendbird.appId;
const botId = config.sendbird.botId;

const ChatWidget = ({
    enableEmojiFeedback = true, 
    enableMention = true, 
    autoOpen = false, 
    enableWidgetExpandButton = false, 
    enableResetHistoryOnConnect = true, 
    betaMark = true
}) => {
    useEffect(() => {
        let toggleButton = document.querySelector('#aichatbot-widget-button');
        let toggleInput = document.getElementById('sendbird-message-input-text-field');

        setTimeout(() => {
            toggleInput = document.getElementById('sendbird-message-input-text-field');
            toggleButton = document.querySelector('#aichatbot-widget-button');
            if (toggleInput instanceof HTMLElement && toggleButton instanceof HTMLElement) {
                toggleInput.classList.add("no-fastclick");
                toggleButton.click();
            }
        }, 1000);
    }, []);

    return (
        <ChatAiWidget
        applicationId={appId}
        botId={botId}
        enableEmojiFeedback={enableEmojiFeedback}
        enableMention={enableMention}
        autoOpen={autoOpen}
        deviceType={window.cordova ? 'mobile' : 'desktop'}
        enableWidgetExpandButton={enableWidgetExpandButton}
        enableResetHistoryOnConnect={enableResetHistoryOnConnect}
        betaMark={betaMark}
    />
    )
}

export default ChatWidget;